import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "./assets/style/main.scss";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import loadercomponent from "./components/Loader/loader.component.vue";
import { Translator } from "vue-google-translate";
import Vuelidate from "vuelidate";
import Carousel3d from "vue-carousel-3d";
import { getBrowserName } from "./utils/browser";
import { detectUserLocation } from "./utils/countryDetection";
import { registerQuickGuideRouter } from "./utils/quickGuides";
import VueTour from "vue-tour";

require("vue-tour/dist/vue-tour.css");
Vue.use(Carousel3d);
Vue.use(VueTour);
Vue.component("loadercomponent", loadercomponent);
Vue.component("Translator", Translator);
Vue.config.productionTip = false;
Vue.prototype.$getBrowserName = getBrowserName;
Vue.prototype.$detectUserLocation = detectUserLocation;

Vue.use(VueSweetalert2);
Vue.use(Vuelidate);
registerQuickGuideRouter(router);
new Vue({
  router,
  store,
  vuetify,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
